<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <edit-business-form
          v-if="userCanEdit"
          data-background-color="secondary"
        />
        <business-summary-card v-else />
      </div>
    </div>
  </div>
</template>

<script>
import EditBusinessForm from "../Forms/EditBusinessForm.vue";
import BusinessSummaryCard from "@/views/Cards/BusinessSummaryCard";

export default {
  components: {
    BusinessSummaryCard,
    EditBusinessForm
  },
  data() {
    return {
      userCanEdit: this.$store.getters.authUser.permissions.includes(
        "update own business"
      )
    };
  }
};
</script>
